import {
  CheckboxField,
  SingleSelectField,
  SwitchInputField,
  TextField,
} from "components/RenderInput"
import React from "react"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field } from "redux-form"

const DetailsTab = () => {
  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>DATE AND TIME</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col xs="auto" className="mt-3">
              <label>All-day</label>
            </Col>
            <Col>
              <Field
                name="allDay"
                component={SwitchInputField}
                uncheckedIcon={false}
                checkedIcon={false}
                onColor="#2ECC71"
                offColor="#E74C3C"
                height={20}
                width={40}
                handleDiameter={18}
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col>
              <Field
                name="displayTime"
                component={CheckboxField}
                label="Display Time"
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs="auto" className="mt-2" style={{ minWidth: "71px" }}>
              <label>Starts</label>
            </Col>
            <Col xs="auto">
              <Field name="startDate" component={TextField} type="date" />
            </Col>
            <Col xs="auto">
              <Field
                name="startHour"
                component={TextField}
                type="number"
                min="1"
                max="12"
                placeholder="HH"
              />
            </Col>
            <Col xs="auto">
              <Field
                name="startMinute"
                component={TextField}
                type="number"
                min="0"
                max="60"
                placeholder="MM"
              />
            </Col>
            <Col xs="auto">
              <div style={{ minWidth: "100px" }}>
                <Field
                  name={"startTimeType"}
                  component={SingleSelectField}
                  placeholder="AM/PM"
                  options={[
                    { label: "AM", value: "AM" },
                    { label: "PM", value: "PM" },
                  ]}
                  isSearchable={false}
                  defaultValue={{ label: "AM", value: "AM" }}
                />
              </div>
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs="auto" className="mt-2" style={{ minWidth: "71px" }}>
              <label>Ends</label>
            </Col>
            <Col xs="auto">
              <Field name="endDate" component={TextField} type="date" />
            </Col>
            <Col xs="auto">
              <Field
                name="endHour"
                component={TextField}
                type="number"
                min="1"
                max="12"
                placeholder="HH"
              />
            </Col>
            <Col xs="auto">
              <Field
                name="endMinute"
                component={TextField}
                type="number"
                min="0"
                max="60"
                placeholder="MM"
              />
            </Col>
            <Col xs="auto">
              <div style={{ minWidth: "100px" }}>
                <Field
                  name={"endTimeType"}
                  component={SingleSelectField}
                  placeholder="AM/PM"
                  options={[
                    { label: "AM", value: "AM" },
                    { label: "PM", value: "PM" },
                  ]}
                  isSearchable={false}
                  defaultValue={{ label: "AM", value: "AM" }}
                />
              </div>
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs="auto" className="mt-2">
              <label>Repeat</label>
            </Col>
            <Col xs="auto">
              <div style={{ minWidth: "150px" }}>
                <Field
                  name={"repeat"}
                  component={SingleSelectField}
                  options={[{ label: "Never", value: "0" }]}
                  isSearchable={false}
                />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card>
        <CardHeader>
          <h4>LOCATION</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col xs="auto" style={{ minWidth: "162px" }} className="mt-2">
              <label>Location</label>
            </Col>
            <Col xs="auto" xl={3}>
              <Field
                name="location"
                component={TextField}
                placeholder="Search for a venue or address"
              />
            </Col>
          </Row>
          <Row className="my-2">
            <Col xs="auto" className="mt-2">
              <label>Zoom Link (Optional)</label>
            </Col>
            <Col xs="auto" xl={3}>
              <Field name="zoomLink" component={TextField} />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default DetailsTab
